<template>
    <main>
        <section class="card">
            <header>
                <span class="active">
                    <span class="hd">1</span>
                    <span class="title">身份证信息录入</span>
                </span>
                <span class="active">
                    <span class="hd">2</span>
                    <span class="title">人脸核验</span>
                </span>
            </header>
            <article class="camera">
                <div>
                    <img ref="scanImg" src="../../../assets/images/account/photo_normal.png" />
                    <video @play="startPlay()" ref="video" :width="200" :height="200" webkit-playsinline playsinline
                        muted :style="{ visibility: launching ? 'hidden' : 'visible' }">
                    </video>
                    <canvas ref="canvas" :width="500" :height="500"
                        :style="{ display: launching || captureing ? 'none' : 'block' }">
                    </canvas>
                </div>
            </article>
            <article class="photo">
                <div>
                    <img src="../../../assets/images/account/photo_blur.png" />
                    <div><span>照片模糊</span></div>
                </div>
                <div>
                    <img src="../../../assets/images/account/photo_side.png" />
                    <div><span>侧面照片</span></div>
                </div>
                <div>
                    <img src="../../../assets/images/account/photo_small.png" />
                    <div><span>大小不合适</span></div>
                </div>
                <div>
                    <img src="../../../assets/images/account/photo_light.png" />
                    <div><span>强烈反光</span></div>
                </div>
            </article>
            <footer>
                <template class="camera" v-if="isMicroMessage">
                    <div class="camera">
                        <input ref="photo" type="file" accept="image/*" @change="choicePhoto()"
                            :capture="canUseUser() ? 'user' : 'camera'" />
                        打开摄像头
                    </div>
                    <van-button :disabled="!choicedImg" class="sysconfirm" @click="confirmCapture()" type="info">确
                        定</van-button>

                </template>
                <template v-else>
                    <van-button v-if="!openCamera" type="info" @click="startCamera()">
                        打开摄像头
                    </van-button>
                    <van-button v-if="openCamera && (launching || captureing)" :disabled="launching"
                        :loading="launching" loading-text="准备开启摄像头..." @click="captureImage()" type="info"
                        role="capture">拍 照</van-button>
                    <van-button type="info" v-if="openCamera && (!launching && !captureing)" @click="confirmCapture()">确
                        定</van-button>
                    <van-button role="recapture" v-if="openCamera && (!launching && !captureing)"
                        @click="recapture()">重新拍摄</van-button>
                </template>
            </footer>
            <p class="declare">声明：人脸识别操作平台不存储任何隐私数据，只调用公安数据进行验证识别</p>
        </section>

    </main>
</template>

<script>
import Vue from 'vue';
import md5 from 'js-md5';
import { Toast } from 'vant';
import { getImageDataWithDir } from '../libs/index';
import {setAlertMessage} from '../../../utils/facAuthFn.js'
const constraints = {
    video: true
};

export default {
    name: 'scan',
    data() {
        return {
            launching: true,
            captureing: false,
            openCamera: false,
            isMicroMessage: true,
            choicedImg: false,
            isFaceA: false, // 是否需要人脸核身
            isShowFaceView: false, // 显示人脸核身内容
            faceAUrl: '',//人脸核身的URL
            userName: this.$route.query.userName,
            idCard: this.$route.query.idCard,
            orderNo:'',
            loading:false,
            timer: null,
            type:'', // 1 腾讯云人脸核身回调回来的 code等于0成功
            code:'',
        }
    },
    computed: {
        idcardBefore() {
            return this.$store.state.idcardBefore
        },
    },
    beforeDestroy() {
        // clearInterval(this.timer);
        // this.timer = null;
        Toast.clear();
        this.currentStream
            && this.currentStream.getTracks()[0]
            && this.currentStream.getTracks()[0].stop();
    },
    mounted() {
        // alert('mountedmountedmountedmounted')
        // alert(window.location.href)
        const base64 = this.$refs.canvas.toDataURL("image/jpeg", 1)
        let frontendConfig = localStorage.getItem('frontendConfig') && JSON.parse(localStorage.getItem('frontendConfig')) || [];
        const faceRecognitionConfig = frontendConfig.find((o) => {
            return o.key === 'face_recognition_config'
        })
        this.isFaceA = faceRecognitionConfig?.value;
        if(this.$route.query.Ftype==1){
            // alert(window.location.href)
            if(this.$route.query.code==0){   
                let orderNo = this.$route.query.orderNo;          
                this.$api.face.updateAccountProfile(orderNo).then(res=>{
                    if(res.success){
                        // 跳转到结果成功页面
                        if (this.idcardBefore?.includes('/modifyPhone')) {
                            this.$router.replace(localStorage.getItem('theme') === 'renshefenguan' ? '/finishExamAuth' : '/authsucc')
                            return
                        }
                        this.pushSuccessPage()
                    }else{
                        Toast('请重新认证')
                    }
                })
            }
            else{
                Toast(setAlertMessage(this.$route.query.code)) 
            }
        }else{
            this.setQueryValue()
        }
    },

    methods: {
        setQueryValue(){
            localStorage.setItem('FcourseId',this.$route.query.courseId||'')
            localStorage.setItem('FtrainId',this.$route.query.trainId||'')
            localStorage.setItem('FstudyProcess',this.$route.query.trastudyProcessinId||'')
            localStorage.setItem('FbackType',this.$route.query.backType||'')
            localStorage.setItem('FtrainItemExamId',this.$route.query.trainItemExamId||'')
            localStorage.setItem('Ftype',this.$route.query.type||'')
            localStorage.setItem('FcontentId',this.$route.query.contentId||'')
            localStorage.setItem('Fid',this.$route.query.id||'')
            localStorage.setItem('FrefId',this.$route.query.refId||'')
            localStorage.setItem('FrefType',this.$route.query.refType||'')
            localStorage.setItem('Frespondlink',this.$route.query.respondlink||'')
        },
        pushSuccessPage(){
            this.$router.push({
                            path: localStorage.getItem('theme') === 'renshefenguan' ? '/finishExamAuth' : '/authsucc', //人社分管跳转定制
                            query: {
                                courseId: localStorage.getItem('FcourseId')|| this.$route.query.courseId,
                                trainId: localStorage.getItem('FtrainId')||this.$route.query.trainId || '',
                                studyProcess: localStorage.getItem('FstudyProcess')|| this.$route.query.studyProcess,
                                backType:localStorage.getItem('FbackType')|| this.$route.query.backType,
                                trainItemExamId:localStorage.getItem('FtrainItemExamId')|| this.$route.query.trainItemExamId,
                                type:localStorage.getItem('Ftype')|| this.$route.query.type,
                                contentId: localStorage.getItem('FcontentId')||this.$route.query.contentId,
                                id: localStorage.getItem('Fid')||this.$route.query.id,
                                refId: localStorage.getItem('FrefId')||this.$route.query.refId,
                                refType: localStorage.getItem('FrefType')||this.$route.query.refType,
                                respondlink: localStorage.getItem('Frespondlink')||this.$route.query.respondlink,
                            }
                        });
                        this.getUserInfo()//更新用户信息
        },
        canUseUser() {
            var ua = navigator.userAgent.toLowerCase();
            var version = null;
            if (ua.indexOf("like mac os x") > 0) {
                return true;
            }
            if (ua.indexOf("android") > 0) {
                var reg = /android [\d._]+/gi;
                var v_info = ua.match(reg);
                version = (v_info + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
                version = parseInt(version.split(".")[0]);
                return version >= 8;
            }
            return false;
        },

        choicePhoto() {
            const file = this.$refs.photo.files[0];

            getImageDataWithDir(file, (base64ImgData) => {
                const scanImg = this.$refs.scanImg;
                scanImg.src = base64ImgData;
                scanImg.onload = () => {
                    const context = this.$refs.canvas.getContext('2d');
                    let minLen = Math.min(scanImg.naturalWidth, scanImg.naturalHeight);
                    let left = scanImg.naturalWidth / 2 - (minLen / 2);
                    let top = scanImg.naturalHeight / 2 - (minLen / 2);
                    context.drawImage(scanImg, left, top, minLen, minLen, 0, 0, 500, 500);
                    this.choicedImg = true;
                    this.launching = false;
                    this.captureing = false;
                }
            });
        },

        startCamera() {
            const video = this.$refs.video;
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                if ('srcObject' in video) {
                    video.srcObject = stream;
                    this.currentStream = stream
                } else {
                    video.src = window.URL.createObjectURL(stream);
                    this.currentStream = stream
                }
                this.$refs.video.load();
                this.$refs.video.play();
            }).catch((err) => {
                Toast.fail("用户摄像头打开失败, 请到设置里开启摄像头权限");
            })
            this.openCamera = true;
        },
        captureImage() {
            const minSize = Math.min(this.$refs.video.videoWidth, this.$refs.video.videoHeight);
            const context = this.$refs.canvas.getContext('2d');
            let left = this.$refs.video.videoWidth / 2 - (minSize / 2);
            let top = this.$refs.video.videoHeight / 2 - (minSize / 2);
            context.drawImage(this.$refs.video, left, top, minSize, minSize, 0, 0, 500, 500);
            this.captureing = false;
        },
        startPlay() {
            this.launching = false;
            this.captureing = true;
        },
        checkFaceA(base64) {
            // 开启人脸核身请求
            this.getFaceADataUrl(base64);
        },
        /*
        获取腾讯云人脸核身url接口
        */
        getFaceADataUrl(base64ImgData) {
           let paramsData = {
                idCard:this.idCard?this.idCard:'',
                userName:this.userName?this.userName:'',
                base64Img:base64ImgData.substring(base64ImgData.indexOf('base64,') + 7),
                domain:window.location.hostname
            }
            this.$api.face.modRedirect({
                data: paramsData
            }).then((res) => {
                if(res.url){
                    window.open(decodeURIComponent(res.url),'_self')
                }

            })
        },
        confirmCapture() {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                className: 'loading',
                loadingType: 'spinner',
                message: '提交中',
            });
            const base64 = this.$refs.canvas.toDataURL("image/jpeg", 1)
            let paramsData = {}
            if (this.isFaceA==='true') {
                paramsData = {
                    userImage: base64.substring(base64.indexOf('base64,') + 7),
                    type: 2
                }
            } else {
                paramsData = {
                    userImage: base64.substring(base64.indexOf('base64,') + 7),
                    type: 1
                }
            }
            this.$api.face.faceverify({
                data: paramsData
            }).then((res) => {
                Toast.clear();
                const userInfo = localStorage.getItem('token');
                if (res.code == 0 && res.data === md5(userInfo + 'true')) { 
                    if (this.idcardBefore?.includes('/modifyPhone')) { // 通过实名认证修改手机号
                        if (this.isFaceA==='true') {
                            this.checkFaceA(base64)
                        } else {
                            this.$router.replace(localStorage.getItem('theme') === 'renshefenguan' ? '/finishExamAuth' : '/authsucc')
                        }
                        return
                    }
                    if (this.isFaceA==='true') {

                        this.checkFaceA(base64)
                    } else {
                        this.pushSuccessPage()
                    }
                } else if (res.code == 50001) {
                    this.$notify({
                        duration: 6000,
                        type: 'danger',
                        message: res.message
                    });
                } else {
                    this.$notify({
                        duration: 6000,
                        type: 'danger',
                        message: '实名认证失败! 请重新尝试'
                    });
                    if (this.idcardBefore.includes('/modifyPhone')) { // 通过实名认证修改手机号
                        this.$router.replace('/authfail')
                        return
                    }
                    this.$router.push('/authfail');
                }
            }).catch((err) => {
                Toast.clear();
                this.$router.push('/authfail')
            });
        },
        recapture() {
            this.captureing = true;
        },
        getUserInfo() {
            this.$api.usercenter.getAccountUserInfo({}).then((res) => {
                localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
                this.$store.commit('setUserInfo', res.data)
            })
        },
    }
}
</script>
<style scoped>
main * {
    position: relative;
}

main {
    display: flex;
    flex-direction: column;
    position: relative;
    /* position: fixed;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px; */
    height: 100vh;
    align-items: center;
    background: #F7F7F7;
}

main>section.card {
    background: white;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 28px;
    left: 28px;
    right: 28px;
}

.iframView {
    width: 100%;
    height: 100vh;
    background-color: #ffffff;
}

.declare {
    position: absolute;
    left: 0;
    bottom: -82px;
    color: red;
    font-size: 24px;
}

header {
    width: 100%;
    display: flex;
    justify-content: space-around;
    text-align: center;
    margin: 30px 0px;
}

header>span {
    display: inline-block;
    color: #737386;
}

header>span>span.hd {
    background-color: #d7dfff;
    color: white;
    text-align: center;
    display: inline-block;
    border-radius: 24px;
    width: 50px;
    height: 50px;
    margin: 0px 10px;
    line-height: 50px;
}

header>span>span.title {
    line-height: 50px;
    top: 2px;
}

header>span.active {
    color: #3660FF;
}

header>span.active:nth-child(1):after {
    content: '';
    border-top: solid 1px rgba(54, 96, 255, 1);
    position: absolute;
    top: 25px;
    right: -70px;
    width: 60px;
    height: 1px;
}

header>span.active>span.hd {
    background-color: #3660ff;
}

article.camera {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 40px 0px;
    width: 10rem;
    height: 10rem;
}

article.camera>div {
    text-align: center;
    width: 100%;
    height: 100%;
}

article.camera video {
    object-fit: cover;
}

article.camera video,
article.camera canvas,
article.camera img {
    position: absolute;
    border-radius: 4.99rem;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
}

article.photo {
    display: flex;
    margin: 40px 0px;
    width: 92%;
    justify-content: space-around;
}

article.photo>div {
    flex: 1;
    text-align: center;
}

article.photo img {
    width: 148px;
    height: 148px;
}

article.photo span {
    font-size: 24px;
    color: #737386;
}

footer {
    margin: 40px 0px;
    width: 95%;
    text-align: center;
    display: flex;
    flex-direction: row;
}

footer .van-button {
    border-radius: 21px;
    font-size: 16px;
    flex: 1;
}

footer .van-button[role=recapture] {
    border-width: 0px;
    color: #3660FF;
}

footer>div.camera {
    background: #1989fa;
    display: inline-block;
    padding: 20px 0px;
    height: 48px;
    border-radius: 40px;
    text-align: center;
    color: white;
    font-size: 32px;
    line-height: 48px;
    flex: 1;
    margin-left: 16px;
    margin-right: 14px;
}

footer>.van-button.sysconfirm {
    display: inline-block;
    padding: 0px;
    margin-left: 14px;
    margin-right: 8px;
    height: 44px !important;
    line-height: 44px !important;
}

footer>div.camera>input {
    opacity: 0;
    position: absolute;
}
</style>

